<app-drawer
  #drawerComponent
  [drawerModel]="drawerData"
  [drawerConfig]="drawerInputConfig"
  [AddDataURL]="addDataUrl"
  [editDataURL]="editDataUrl"
  (refresh)="refreshHandler()"
  [createDrawerTitle]="'Create New Practice Load Configuration'"
  [updateDrawerTitle]="'Update Practice Load Configuration'"
  (resetData)="resetEntry()"
></app-drawer>

<!-- Loader overlay while applying smart schedule -->
<div *ngIf="isApplyingSchedule"
  class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-white opacity-75 flex flex-col items-center justify-center">
  <div class="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-indigo-500"></div>
  <p class="mt-4 text-gray-700 regular-font">Applying smart schedule...</p>
</div>

<app-dynamic-grid
  [gridConfig]="gridConfig"
  [getDataUrl]="getDataUrl"
  [toggleUrl]="toggleUrl"
  [sortBy]="'modifiedAt'"
  [sortOrder]="'desc'"
  [extraActions]="gridExtraActions"
  (addClicked)="onAddHandler($event)"
  (editClicked)="onEditHandler($event)"
  (onToggleShowToastEmitter)="showToast($event)"
></app-dynamic-grid>
<app-toast></app-toast>

<!-- Smart Schedule Confirmation Dialog -->
<div *ngIf="showSmartScheduleConfirm"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <div class="relative transform overflow-hidden bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
    <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
      <div class="sm:flex sm:items-start">
        <div class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-indigo-100 sm:mx-0 sm:h-10 sm:w-10">
          <svg class="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
        </div>
        <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
          <h3 class="text-base font-semibold leading-6 text-gray-900">Apply Smart Schedule</h3>
          <div class="mt-2">
            <p class="text-sm text-gray-500">
              This will automatically categorize all active practices by load duration and assign them to schedules —
              live practices first, then non-live. This will update all load configurations.
            </p>
            <p class="mt-2 text-sm text-gray-500">Are you sure you want to proceed?</p>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-gray-50 px-4 py-3 gap-3 sm:flex sm:flex-row-reverse sm:px-6">
      <button (click)="confirmApplySmartSchedule()" type="button"
        class="px-6 py-1.5 bg-indigo-500 text-gray-200 hover:bg-indigo-400 regular-font transition-colors duration-500 shadow-md focus:outline-none ring-offset-1 focus:ring-2">
        Confirm
      </button>
      <button (click)="cancelSmartSchedule()" type="button"
        class="px-6 py-1.5 bg-gray-600 hover:bg-gray-500 text-gray-50 regular-font transition-colors duration-500 shadow-md focus:outline-none ring-offset-1 focus:ring-2 ring-gray-400">
        Cancel
      </button>
    </div>
  </div>
</div>
